import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

/**
 * Upload files via POST multipart/form-data.
 * Params: files (File[] with filename+extension), poId (when update), ArqID (when update, or "").
 * @param {{ files: File[], purchaseOrderId?: string, arqId?: string }}
 */
const uploadPoAttachmentQuery = ({ files, purchaseOrderId, arqId }) => {
  const formData = new FormData();
  const fileList = Array.isArray(files) ? files : (files ? [files] : []);
  fileList.forEach((file) => formData.append('files', file));

  formData.append('poId', purchaseOrderId ?? '');
  formData.append('ArqID', arqId ?? '');

  return axios.post(apiurl?.uploadPoAttachment, formData, {
    headers: {
      Accept: '*/*'
    }
  });
};

const uploadPoAttachment = () => {
  const queryClient = useQueryClient();
  return useMutation(uploadPoAttachmentQuery, {
    onSuccess: (_, variables) => {
      const poId = variables?.purchaseOrderId;
      const arqId = variables?.arqId ?? null;
      if (poId) {
        // Invalidate only this context (PO or ARQ) so ARQ uploads don't refetch PO attachments
        queryClient.invalidateQueries(['getPoAttachments', poId, arqId]);
      }
    }
  });
};

export default uploadPoAttachment;
